var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useMemo, useState } from 'react';
import { TagType, WidgetType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import Tags from '@shared/tags/Tags';
import Modal from '@shared/modal/Modal';
import { TagNameDisplay } from '@data/types';
import Manager from '@shared/modal/Manager';
import TextInput from '@shared/input/TextInput';
import { CheckBox } from '@shared/input/CheckBox';
import ModalHeader from '@shared/modal/ModalHeader';
import ModalFooter from '@shared/modal/ModalFooter';
import { useTagContext } from '@data/tag/tagContext';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCreateWidget, useUpdateWidget } from '@data/widgets/widgetActions';
import { ModalBody } from '@styled/Modal';
import { FormField, FormFieldLabel } from '@styled/Form';
import { FlexRow } from '@styled/FlexWrappers';
import RadioInput from '@shared/input/RadioInput';
function TagSlicerEditor(props) {
    return (React.createElement(Modal, { width: 600 },
        React.createElement(TagSlicerEditorForm, __assign({}, props))));
}
var TagSlicerEditorForm = function (props) {
    var L = useLanguage().L;
    var createWidget = useCreateWidget();
    var updateWidget = useUpdateWidget();
    var tagData = useTagContext().tagData;
    var _a = __read(useState(props.widget
        ? props.widget
        : {
            title: '',
            type: WidgetType.TAGSLICER,
            config: JSON.stringify(parseWidgetConfig(null, WidgetType.TAGSLICER)),
            GridId: props.gridId,
        }), 2), widgetState = _a[0], setWidgetState = _a[1];
    var _b = __read(useState({}), 2), invalid = _b[0], setInvalid = _b[1];
    var validate = function (payload, payloadConfig) {
        var invalid = {};
        return invalid;
    };
    var done = function () { return __awaiter(void 0, void 0, void 0, function () {
        var widgetCopy, widgetCopyConfig, propsWidgetConfig, _invalid, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    widgetCopy = __assign({}, widgetState);
                    widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
                    if (props.widget !== undefined) {
                        propsWidgetConfig = parseWidgetConfig(props.widget.config, WidgetType.TAGSLICER);
                    }
                    _invalid = validate(widgetCopy, widgetCopyConfig);
                    if (!(Object.keys(_invalid).length > 0)) return [3 /*break*/, 1];
                    setInvalid(_invalid);
                    return [3 /*break*/, 6];
                case 1:
                    widgetCopy.config = JSON.stringify(widgetCopyConfig);
                    if (!('id' in widgetCopy)) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createWidget.mutateAsync(widgetCopy)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    _a;
                    Manager.closeModal();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var setTitle = function (newTitle) {
        var widgetCopy = __assign({}, widgetState);
        widgetCopy.title = newTitle;
        setWidgetState(widgetCopy);
    };
    var setMultipleSelect = function (val) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
        widgetCopyConfig.multipleSelect = val;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var onTagSlicerTagSelect = function (tagId) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
        var tagIds = widgetCopyConfig.tagSlicerTags;
        tagIds.push(tagId);
        widgetCopyConfig.tagSlicerTags = tagIds;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var onTagSlicerTagRemove = function (tagId) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
        var tagIds = widgetCopyConfig.tagSlicerTags.filter(function (tid) { return tid !== tagId; });
        widgetCopyConfig.tagSlicerTags = tagIds;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var onFilterTagSelect = function (tagId) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
        var tagIds = widgetCopyConfig.tagSlicerFilterTagIds;
        tagIds.push(tagId);
        widgetCopyConfig.tagSlicerFilterTagIds = tagIds;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var onFilterTagRemove = function (tagId) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
        var tagIds = widgetCopyConfig.tagSlicerFilterTagIds.filter(function (tid) { return tid !== tagId; });
        widgetCopyConfig.tagSlicerFilterTagIds = tagIds;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var onOnlyWithDataDimensionSelect = function (tagId) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
        var tagIds = widgetCopyConfig.onlyWithDataDimensionIds;
        tagIds.push(tagId);
        widgetCopyConfig.onlyWithDataDimensionIds = tagIds;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var onOnlyWithDataDimensionRemove = function (tagId) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
        var tagIds = widgetCopyConfig.onlyWithDataDimensionIds.filter(function (tid) { return tid !== tagId; });
        widgetCopyConfig.onlyWithDataDimensionIds = tagIds;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var onOnlyWithDataAccountChange = function (tagId) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
        widgetCopyConfig.onlyWithDataAccountId = tagId;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var rowNameDisplayHandler = function (value) {
        var widgetCopy = __assign({}, widgetState);
        var widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.TAGSLICER);
        widgetCopyConfig.tagNameDisplay = value;
        widgetCopy.config = JSON.stringify(widgetCopyConfig);
        setWidgetState(widgetCopy);
    };
    var widgetConfig = useMemo(function () { return parseWidgetConfig(widgetState.config, WidgetType.TAGSLICER); }, [widgetState.config]);
    var tagSlicerTags = widgetConfig.tagSlicerTags
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (t) { return t !== undefined; });
    var tagSlicerFilterTags = widgetConfig.tagSlicerFilterTagIds
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (t) { return t !== undefined; });
    var onlyWithDataAccountTags = [];
    if (widgetConfig.onlyWithDataAccountId) {
        var tag = tagData.tagById[widgetConfig.onlyWithDataAccountId];
        if (tag) {
            onlyWithDataAccountTags.push(tag);
        }
    }
    var onlyWithDataDimensionTags = widgetConfig.onlyWithDataDimensionIds
        .map(function (tagId) { return tagData.tagById[tagId]; })
        .filter(function (t) { return t !== undefined; });
    var title = props.widget
        ? "".concat(L('Editing Dimension Slicer'), " \"").concat(props.widget.title, "\"")
        : L('Create new Dimension Slicer');
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(FlexRow, { style: { alignItems: 'center' } },
                    React.createElement(FormField, { "$bottomSpace": true },
                        React.createElement(Tags, { canAddOnlyOneTag: true, afterButtonLabel: L('Table'), afterButtonLabelType: TagType.Table, tags: tagSlicerTags, select: onTagSlicerTagSelect, remove: onTagSlicerTagRemove, filterByTypes: [TagType.Table] })),
                    React.createElement(FormField, { "$bottomSpace": true, style: { flexGrow: 0 } },
                        React.createElement(CheckBox, { action: function () {
                                setMultipleSelect(!widgetConfig.multipleSelect);
                            }, checked: widgetConfig.multipleSelect, label: L('Enable Multiselect') }))),
                React.createElement(TextInput, { placeholder: L('Enter Title...'), value: widgetState.title, name: "title", onChange: function (e) { return setTitle(e.target.value); }, bottomMargin: true }),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Tag name display')),
                    React.createElement(FlexRow, null,
                        React.createElement(RadioInput, { action: function () { return rowNameDisplayHandler(TagNameDisplay.Name); }, checked: widgetConfig.tagNameDisplay === TagNameDisplay.Name, category: 'rowNameDisplay', label: L('Name') }),
                        React.createElement(RadioInput, { action: function () { return rowNameDisplayHandler(TagNameDisplay.Description); }, checked: widgetConfig.tagNameDisplay === TagNameDisplay.Description, category: 'rowNameDisplay', label: L('Description') }),
                        React.createElement(RadioInput, { action: function () { return rowNameDisplayHandler(TagNameDisplay.Both); }, checked: widgetConfig.tagNameDisplay === TagNameDisplay.Both, category: 'rowNameDisplay', label: L('Both') }))),
                React.createElement(FormFieldLabel, { style: { fontWeight: 'bold', paddingTop: '25px', paddingBottom: '15px' } }, L('Filters')),
                React.createElement(FormField, null,
                    React.createElement(FormFieldLabel, null, L('By Dimension')),
                    React.createElement(Tags, { tags: tagSlicerFilterTags, select: onFilterTagSelect, remove: onFilterTagRemove, filterByTypes: [TagType.Dimension] })),
                React.createElement(FormFieldLabel, { style: { paddingTop: '10px' } }, L('Show Only Dimensions With Data In...')),
                React.createElement(FlexRow, null,
                    React.createElement(FormField, null,
                        React.createElement(Tags, { canAddOnlyOneTag: true, afterButtonLabel: L('Variable'), afterButtonLabelType: TagType.Account, tags: onlyWithDataAccountTags, select: function (tagId) { return onOnlyWithDataAccountChange(tagId); }, remove: function () { return onOnlyWithDataAccountChange(null); }, filterByTypes: [TagType.Account] })),
                    React.createElement(FormField, null,
                        React.createElement(Tags, { afterButtonLabel: L('Dimensions'), afterButtonLabelType: TagType.Dimension, tags: onlyWithDataDimensionTags, select: onOnlyWithDataDimensionSelect, remove: onOnlyWithDataDimensionRemove, filterByTypes: [TagType.Dimension] }))))),
        React.createElement(ModalFooter, { done: done })));
};
export default TagSlicerEditor;
